module.exports = __webpack_public_path__ + "img/alien-silhouette.478bb3a0.webp";